'use strict';

var FormatTextObject = function(){

    function init(){
    }

    function dispose(){
        console.log('FormatText | Dispose::');

    }

    function removeSpecialCharacters(text){
        var special = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç';
        var replacement = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc';
        for (var i=0; i<special.length; i++) {
            if(text){
                text = text.replace(special.charAt(i), replacement.charAt(i));				
            }
        }
        
        return text;
    }

    function testEmail(email){
        console.log('FormatText | testEmail');
        console.log(email);
        
        var pattern = /^[a-zA-Z0-9._-]+@[^\.][a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
        if (!pattern.test(email)) {
            console.log('email no válido');
            return false;
        }else{
            console.log('email válido');
            return true;
        }	
    }

    function testStandard(text){
        console.log('FormatText | testStandard');

        if(text){
            text = text.trim();

            if(text.length > 2){
                return true;
            }else{
                return false;
            }
        }else{
            return false;
        }
    }

    function capitalize(word){
        return word.substr(0, 1).toUpperCase() + word.substr(1);
    }


    //////// PUBLIC INTERFACE /////////

    this.namespace = 'FORMATTEXT';
    this.dispose = dispose;
    this.removeSpecialCharacters = removeSpecialCharacters;
    this.testEmail = testEmail;
    this.testStandard = testStandard;
    this.capitalize = capitalize;


    init();
}

var FormatText = new FormatTextObject();
